(function () {
  if (!window.location.pathname.includes('/collections/')) return;

  const FACET_SELECTORS = [
    '.facets__form',
    '.facets__form--desktop',
    '.facets__form--mobile',
    '.facets-mobile',
    '.facets-container',
    '.facets-container--drawer',
    '.collection-filters',
    '.collection__filters',
    '.filter-and-sort',
    '.sort-by',
    'facet-filters-form',
    '#FacetFiltersForm',
    '#FacetFiltersFormMobile',
    '#FacetSortForm',
    'button.button--small.button--outline',
  ].join(', ');

  let loading = false;
  let currentPage = 2;
  let allLoaded = false;
  let seenProducts = new Set();
  let observer = null;
  let reinitTimer = null;
  let isIniting = false;
  let observeTimer = null;

  function getProductFingerprints(grid) {
    return Array.from(grid.querySelectorAll('a[href*="/products/"]')).map((a) => a.href);
  }

  function hidePagination() {
    document.querySelectorAll('.pagination').forEach((el) => (el.style.display = 'none'));
  }

  function hideExtraFacets() {
    const seen = new Set();
    document.querySelectorAll(FACET_SELECTORS).forEach((el) => {
      const key = el.tagName + (el.id || el.className);
      if (seen.has(key)) {
        el.style.display = 'none';
      } else {
        seen.add(key);
      }
    });
  }

  function stripFacetsFromItem(item) {
    item.querySelectorAll(FACET_SELECTORS).forEach((f) => f.remove());
  }

  function showEndOfCollection() {
    const loader = document.getElementById('scroll-loader');
    const endBlock = document.getElementById('end-of-collection');
    if (loader) loader.style.display = 'none';
    if (endBlock) {
      endBlock.style.display = 'block';
      setTimeout(() => {
        endBlock.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 150);
    }
  }

  // Fetch next page inside a hidden iframe so Timesact runs on it
  // and badges are already injected before we extract the cards
  function fetchProcessedPage(url) {
    return new Promise((resolve) => {
      const iframe = document.createElement('iframe');
      iframe.style.cssText = 'position:absolute;width:1px;height:1px;opacity:0;pointer-events:none;left:-9999px;top:-9999px;';
      iframe.src = url;
      document.body.appendChild(iframe);

      iframe.onload = function () {
        // Wait 1500ms for Timesact to finish injecting badges inside the iframe
        setTimeout(() => {
          try {
            const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
            const grid = iframeDoc.querySelector('.main-collection-product-grid');
            document.body.removeChild(iframe);
            resolve(grid);
          } catch (e) {
            // Cross-origin or other error — fall back to null
            if (document.body.contains(iframe)) document.body.removeChild(iframe);
            resolve(null);
          }
        }, 1500);
      };

      iframe.onerror = function () {
        if (document.body.contains(iframe)) document.body.removeChild(iframe);
        resolve(null);
      };
    });
  }

  // Fallback reinit if iframe approach ever returns null
  function reinitTimesact() {
    setTimeout(function () {
      // Method 1: Custom event
      document.dispatchEvent(new CustomEvent('timesact:reinit'));

      // Method 2: Global object
      if (window.Timesact && typeof window.Timesact.init === 'function') {
        window.Timesact.init();
      } else if (window.TimesactPreOrder && typeof window.TimesactPreOrder.init === 'function') {
        window.TimesactPreOrder.init();
      }

      // Method 3: DOMContentLoaded re-dispatch
      document.dispatchEvent(new Event('DOMContentLoaded'));

      // Method 4: Re-execute Timesact script (cache-busted)
      const timesactScript = document.querySelector('script[src*="timesact"]');
      if (timesactScript) {
        const newScript = document.createElement('script');
        newScript.src = timesactScript.src + '?t=' + Date.now();
        document.head.appendChild(newScript);
      }
    }, 150);
  }

  function teardown() {
    clearTimeout(observeTimer);

    if (observer) {
      observer.disconnect();
      observer = null;
    }
    ['scroll-sentinel', 'scroll-loader', 'end-of-collection'].forEach((id) => {
      const el = document.getElementById(id);
      if (el) el.remove();
    });

    hidePagination();
  }

  function scheduleReinit() {
    if (loading) return;
    hidePagination();
    clearTimeout(reinitTimer);
    reinitTimer = setTimeout(init, 800);
  }

  function init() {
    if (isIniting) return;
    isIniting = true;

    teardown();

    const productGrid = document.querySelector('.main-collection-product-grid');
    if (!productGrid) {
      isIniting = false;
      return;
    }

    loading = false;
    currentPage = 2;
    allLoaded = false;
    seenProducts = new Set(getProductFingerprints(productGrid));

    hidePagination();
    hideExtraFacets();

    // Loader spinner
    const loader = document.createElement('div');
    loader.id = 'scroll-loader';
    loader.innerHTML = '<div class="spinner"></div>';
    productGrid.insertAdjacentElement('afterend', loader);

    // End of collection block
    const endBlock = document.createElement('div');
    endBlock.id = 'end-of-collection';

    const noContentMessage = document.createElement('p');
    noContentMessage.id = 'no-content-message';
    noContentMessage.innerText = "You've reached the end of the collection.";

    const backToTopBtn = document.createElement('button');
    backToTopBtn.id = 'back-to-top';
    backToTopBtn.innerHTML = '⬆ Scroll Back to Top';
    backToTopBtn.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    endBlock.appendChild(noContentMessage);
    endBlock.appendChild(backToTopBtn);
    loader.insertAdjacentElement('afterend', endBlock);

    // Sentinel
    const sentinel = document.createElement('div');
    sentinel.id = 'scroll-sentinel';
    sentinel.style.height = '1px';
    loader.insertAdjacentElement('beforebegin', sentinel);

    isIniting = false;

    function loadMoreProducts() {
      if (loading || allLoaded) return;

      const baseSearch = window.location.search
        ? window.location.search + '&'
        : '?';
      const url = `${window.location.pathname}${baseSearch}page=${currentPage}`;
      loading = true;
      loader.style.display = 'block';

      fetchProcessedPage(url).then((newProducts) => {
        loader.style.display = 'none';

        if (newProducts && newProducts.children.length > 0) {
          const fetchedFingerprints = getProductFingerprints(newProducts);
          const allDuplicates = fetchedFingerprints.every((fp) => seenProducts.has(fp));

          if (allDuplicates || fetchedFingerprints.length === 0) {
            allLoaded = true;
            observer.disconnect();
            showEndOfCollection();
            return;
          }

          fetchedFingerprints.forEach((fp) => seenProducts.add(fp));

          Array.from(newProducts.children).forEach((item) => {
            if (item.matches(FACET_SELECTORS + ', .collection-product-count, .no-content-message')) return;
            stripFacetsFromItem(item);
            item.querySelectorAll('.collection-product-count, .no-content-message').forEach((f) => f.remove());
            productGrid.appendChild(item.cloneNode(true));
          });

          hidePagination();
          currentPage++;
          loading = false;

        } else {
          // iframe returned null — fall back to fetch() + reinitTimesact()
          fetch(url)
            .then((res) => res.text())
            .then((html) => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');
              const fallbackProducts = doc.querySelector('.main-collection-product-grid');

              loader.style.display = 'none';

              if (fallbackProducts && fallbackProducts.children.length > 0) {
                const fetchedFingerprints = getProductFingerprints(fallbackProducts);
                const allDuplicates = fetchedFingerprints.every((fp) => seenProducts.has(fp));

                if (allDuplicates || fetchedFingerprints.length === 0) {
                  allLoaded = true;
                  observer.disconnect();
                  showEndOfCollection();
                  return;
                }

                fetchedFingerprints.forEach((fp) => seenProducts.add(fp));

                Array.from(fallbackProducts.children).forEach((item) => {
                  if (item.matches(FACET_SELECTORS + ', .collection-product-count, .no-content-message')) return;
                  stripFacetsFromItem(item);
                  item.querySelectorAll('.collection-product-count, .no-content-message').forEach((f) => f.remove());
                  productGrid.appendChild(item.cloneNode(true));
                });

                // Use reinitTimesact as fallback since iframe failed
                reinitTimesact();

                hidePagination();
                currentPage++;
                loading = false;
              } else {
                allLoaded = true;
                observer.disconnect();
                showEndOfCollection();
              }
            })
            .catch(() => {
              loader.style.display = 'none';
              loading = false;
            });
        }
      });
    }

    observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && !loading && !allLoaded) {
        loadMoreProducts();
      }
    }, { rootMargin: '300px' });

    observeTimer = setTimeout(() => {
      if (sentinel && observer) {
        observer.observe(sentinel);
      }
    }, 400);

    attachMobileListeners();
  }

  function attachMobileListeners() {
    document.querySelectorAll(
      '#FacetFiltersFormMobile select, #FacetSortForm select, .facets__form--mobile select, .facets-mobile select'
    ).forEach((el) => {
      el.addEventListener('change', scheduleReinit);
    });

    document.querySelectorAll(
      '#FacetFiltersFormMobile input, .facets__form--mobile input, .facets-mobile input'
    ).forEach((el) => {
      el.addEventListener('change', scheduleReinit);
    });

    document.querySelectorAll(
      '#FacetFiltersFormMobile, .facets__form--mobile, .facets-mobile'
    ).forEach((form) => {
      form.addEventListener('submit', scheduleReinit);
    });

    document.querySelectorAll(
      '.facets__form--mobile button[type="submit"], .facets-mobile button[type="submit"], #FacetFiltersFormMobile button[type="submit"]'
    ).forEach((btn) => {
      btn.addEventListener('click', scheduleReinit);
    });
  }

  // Inject styles once
  const style = document.createElement('style');
  style.textContent = `
    #scroll-loader {
      display: none;
      text-align: center;
      padding: 20px;
    }
    #scroll-loader .spinner {
      width: 40px;
      height: 40px;
      border: 4px solid #B932236f;
      border-top-color: #B93223;
      border-radius: 50%;
      animation: spin 0.8s linear infinite;
      margin: 0 auto;
    }
    @keyframes spin {
      to { transform: rotate(360deg); }
    }
    #end-of-collection {
      display: none;
      text-align: center;
      width: 100%;
      padding: 30px 0 50px;
      clear: both;
    }
    #no-content-message {
      font-size: 14px;
      color: #666;
      margin: 0 0 16px;
    }
    #back-to-top {
      display: inline-block;
      padding: 14px 32px;
      background-color: #B93223;
      color: #fff;
      border: none;
      border-radius: 4px;
      font-size: 15px;
      font-weight: 500;
      cursor: pointer;
      box-shadow: 0 4px 16px rgba(0,0,0,0.25);
      transition: opacity 0.3s ease;
      white-space: nowrap;
    }
    #back-to-top:hover {
      opacity: 0.8;
    }
    .pagination {
      display: none !important;
    }
  `;
  document.head.appendChild(style);

  // Initial load
  init();

  // Watch for URL changes via pushState
  let lastUrl = window.location.href;
  const urlObserver = new MutationObserver(() => {
    if (window.location.href !== lastUrl) {
      lastUrl = window.location.href;
      scheduleReinit();
    }
  });
  urlObserver.observe(document.body, { childList: true, subtree: true });

  // Handle back/forward navigation
  window.addEventListener('popstate', scheduleReinit);

})();
